// Actions
import * as Actions from 'actionTypes';

type ActionShortlist = {
  type: string,
  shortlistCmsIds: Array<string>
};

export default (
  state: Object = {
    shortlistCmsIds: []
  },
  action: ActionShortlist
): Object => {
  if (action.type === Actions.UPDATE_SHORTLIST) {
    return {
      ...state,
      shortlistCmsIds: action.shortlistCmsIds
    };
  } else if (action.type === Actions.UPDATE_SHORTLIST_FAILED) {
    return {
      ...state,
      error: true
    };
  }

  return state;
};



// WEBPACK FOOTER //
// ./src/reducers/shortlist.reducer/index.js